import {Injectable} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {forkJoin, map, Observable} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class EnumTranslationHelperService {

  constructor(
    private translateService: TranslateService
  ) {}

  // example
  // baseKey: 'TICKET-TABLE.STATUS.'
  // enumClass: TicketAntragStatus
  // filterFunction: (v) => listOfValsAllowedForRole.includes(v)
  // sortFunction: (a,b) => (a-b) > 0
  getTranslationObservableForEnumByValue<T, V>(
    enumClass: T,
    baseKey = '',
    filterFunction: (value: V) => boolean = () => true, // default filter filters nothing
    sortFunction: (a: V, b: V) => number = () => 0 // default sorter sorts nothing
  )
    : Observable<any>
  {

    const vals = Object.values(enumClass);
    if(!vals)
      return null;

    const filteredAndSortedValues = vals.filter(filterFunction).sort(sortFunction);
    const translationObservables = filteredAndSortedValues.map(v => this.translateService.get(baseKey + v));

    return forkJoin(translationObservables).pipe(
      map(translations => {
        const translationMap = {};
        filteredAndSortedValues.forEach((v, index) => {
          translationMap[v] = translations[index];
        });

        return vals
          .filter(v => translationMap[v] !== undefined)
          .map(v => ({ value: v, display: translationMap[v] }));
      })
    );

  }

}
